import { Component, ViewEncapsulation } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { PATHS } from 'shared/paths';
import { Article } from 'shared/types';
import { Page, Section, SubSection } from '../../../../../shared/location-enums';

@Component({
    selector: 'app-connect-with-gard',
    templateUrl: './h5-contact-us.component.html',
    styleUrls: ['./h5-contact-us.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class H5ContactUsComponent {
    public image: string;
    public imageAlt: string;
    public titleKa: Article;
    public formKa: Article;
    public buttonKa: Article;
    public buttonUrl: string;

    constructor(articleService: ArticleService) {
        this.titleKa = articleService.getOne(Page.home, Section.contactUs, undefined, 1);
        this.formKa = articleService.getOne(Page.home, Section.contactUs, undefined, 4);
        this.buttonKa = articleService.getOne(Page.home, Section.contactUs, undefined, 5);
        this.buttonUrl = articleService.getOne(Page.home, Section.contactUs, SubSection.homeContactFormButton).bodyText;
        const primaryImage = this.titleKa.images?.[0];
        this.image = primaryImage?.url ? PATHS.articleImages + primaryImage.url + '-800.webp' : '';
        this.imageAlt = primaryImage?.altText ?? '';
    }
}
